import React from 'react'
import ReactApexChart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { NftDay } from 'state/nft/types'

function NftStatChart({ days }: { days: NftDay[] }) {
  const series = [
    {
      name: 'Floor Price',
      data: days?.map(item => [item.lastUpdatedAt, Number(item.floorPrice).toFixed(2)])
    }
  ]

  const options: ApexOptions = {
    chart: {
      type: 'area',
      height: 300,
      zoom: {
        enabled: false
      },
      background: '#18191E'
    },
    tooltip: {
      theme: 'dark'
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'straight',
      width: 1.2
    },
    fill: {
      type: 'gradient',
      gradient: {
        opacityFrom: 0.6,
        opacityTo: 0.1
      }
    },
    xaxis: {
      type: 'datetime',
      labels: {
        formatter: value => new Date(value).toDateString()
      }
    },
    legend: {
      horizontalAlign: 'left'
    },
    theme: {
      mode: 'dark',
      palette: 'palette6'
    }
  }

  return <ReactApexChart options={options} series={series} type="area" width="100%" height={300} />
}

export default NftStatChart
